/* PLAYOUTLET — theme.js */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CFG = window.pol || {};

  /* ---------- Formatage prix ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Tiroirs ---------- */
  var overlay = $('.overlay');
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    var f = el.querySelector('button,a,input');
    if (f) f.focus();
  }
  function closeDrawers() {
    $$('.drawer').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer($('#' + open.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('overlay')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Header au scroll + retour haut ---------- */
  var header = $('.header'), top = $('.to-top'), tick = false;
  function onScroll() {
    if (tick) return;
    tick = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset;
      if (header) header.classList.toggle('is-stuck', y > 12);
      if (top) top.classList.toggle('is-on', y > 700);
      tick = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- Compte à rebours (minuit) ---------- */
  function countdowns() {
    var hosts = $$('[data-countdown]');
    if (!hosts.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tickCd() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      hosts.forEach(function (host) {
        var a = host.querySelector('[data-h]'), b = host.querySelector('[data-m]'), c = host.querySelector('[data-s]');
        if (a) a.firstChild.nodeValue = pad(h);
        if (b) b.firstChild.nodeValue = pad(m);
        if (c) c.firstChild.nodeValue = pad(s);
      });
    }
    tickCd();
    setInterval(tickCd, 1000);
  }

  /* ---------- Date de livraison estimée ---------- */
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function ouvres(d, n) {
    var x = new Date(d.getTime()), i = 0;
    while (i < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) i++; }
    return x;
  }
  function fmtDate(d) { return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()]; }
  function delivery() {
    var els = $$('[data-delivery]');
    if (!els.length) return;
    var cfg = CFG.delivery || { min: 2, max: 4, cutoff: 15 };
    var base = new Date();
    if (base.getHours() >= cfg.cutoff) base = ouvres(base, 1);
    var d1 = ouvres(base, cfg.min), d2 = ouvres(base, cfg.max);
    els.forEach(function (el) {
      el.innerHTML = 'Livraison gratuite estimée entre <b>' + fmtDate(d1) + '</b> et <b>' + fmtDate(d2) + '</b>.';
    });
  }

  /* ---------- Panier : ajout AJAX ---------- */
  function refreshCartCount() {
    fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        renderDrawer(cart);
      })
      .catch(function () { });
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    return fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) { toast(res.data.description || 'Produit indisponible'); return; }
        if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); }
        refreshCartCount();
        openDrawer($('#cart-drawer'));
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        toast('Erreur réseau, réessayez.');
      });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart(quick.getAttribute('data-quick-add'), 1, quick);
    }
  });

  /* ---------- Rendu du tiroir panier ---------- */
  function renderDrawer(cart) {
    var body = $('[data-cart-items]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty" style="padding:48px 0"><p>Votre panier est vide.</p><a class="btn btn--primary" href="/collections/all">Voir les offres</a></div>';
      var f = $('[data-cart-foot]'); if (f) f.hidden = true;
      return;
    }
    var html = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<div class="line">' +
        '<div class="line__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="96" height="96">' : '') + '</div>' +
        '<div><p class="line__t">' + it.product_title + '</p>' +
        (it.variant_title ? '<p class="line__v">' + it.variant_title + '</p>' : '') +
        '<div class="qty"><button type="button" data-line-qty="' + it.key + '" data-dir="-1" aria-label="Réduire">−</button>' +
        '<input type="number" value="' + it.quantity + '" min="0" data-line-input="' + it.key + '" aria-label="Quantité">' +
        '<button type="button" data-line-qty="' + it.key + '" data-dir="1" aria-label="Augmenter">+</button></div>' +
        '<button class="line__rm" type="button" data-line-remove="' + it.key + '">Retirer</button></div>' +
        '<div class="line__p">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    body.innerHTML = html;
    var foot = $('[data-cart-foot]');
    if (foot) { foot.hidden = false; var t = $('[data-cart-total]'); if (t) t.textContent = money(cart.total_price); }
  }

  function changeLine(key, qty) {
    fetch(CFG.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      var key = q.getAttribute('data-line-qty');
      var input = $('[data-line-input="' + key + '"]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-dir'), 10));
      changeLine(key, next);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) changeLine(rm.getAttribute('data-line-remove'), 0);
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.getAttribute('data-line-input'), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Quantité (PDP) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
    input.value = v;
  });

  /* ---------- Galerie produit ---------- */
  function gallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full');
        main.alt = t.querySelector('img') ? t.querySelector('img').alt : '';
        $$('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Variantes ---------- */
  function variants() {
    var root = $('[data-product-root]');
    if (!root) return;
    var dataEl = $('[data-variants-json]');
    if (!dataEl) return;
    var list = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]');
    var btn = $('[data-add-btn]');
    var priceNow = $('[data-price-now]');
    var priceWas = $('[data-price-was]');
    var priceSave = $('[data-price-save]');
    var main = $('[data-gallery-main]');

    function selected() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (i) { return i.value; });
    }

    function update() {
      var opts = selected();
      var v = list.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        var has = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.textContent = has ? money(v.compare_at_price) : '';
        priceWas.hidden = !has;
        if (priceSave) {
          var pct = has ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
          priceSave.textContent = has ? '−' + pct + ' % (' + money(v.compare_at_price - v.price) + ')' : '';
          priceSave.hidden = !has;
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? CFG.strings.addToCart : CFG.strings.soldOut;
      }
      if (v.featured_image && main) main.src = v.featured_image.src;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      var bb = $('[data-buybar-price]');
      if (bb) bb.textContent = money(v.price);
      updateStock(v);
    }
    $$('[data-option-index]', root).forEach(function (i) { i.addEventListener('change', update); });
    update();
  }

  /* ---------- Jauge de stock ---------- */
  function updateStock(v) {
    var host = $('[data-stock-host]');
    if (!host) return;
    var threshold = CFG.lowStock || 10;
    var tracked = v.inventory_management && v.inventory_policy === 'deny';
    var qty = v.inventory_quantity || 0;

    if (!v.available) { host.innerHTML = ''; return; }

    if (tracked && qty > 0 && qty <= threshold) {
      var pct = Math.max(6, Math.round((qty / threshold) * 100));
      host.innerHTML =
        '<div class="stock"><div class="stock__bar"><div class="stock__fill" style="width:' + pct + '%"></div></div>' +
        '<p class="stock__txt"><span class="stock__dot"></span>Plus que ' + qty + ' en stock</p></div>';
    } else {
      host.innerHTML =
        '<div class="stock"><p class="stock__txt stock__txt--ok"><span class="stock__dot"></span>' +
        'En stock, expédition sous 24 h</p></div>';
    }
  }

  /* ---------- Recommandations (API Shopify) ---------- */
  function recommendations() {
    $$('[data-recommendations]').forEach(function (host) {
      var url = host.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.querySelector('.pcard')) {
            host.innerHTML = fresh.innerHTML;
          } else {
            host.remove();
          }
        })
        .catch(function () { host.remove(); });
    });
  }

  /* ---------- Récemment consultés ---------- */
  var RV_KEY = 'pol:viewed';

  function rememberProduct() {
    var el = $('[data-product-handle]');
    if (!el) return;
    var handle = el.getAttribute('data-product-handle');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }

  function recentlyViewed() {
    var host = $('[data-recently-viewed]');
    if (!host) return;
    var grid = $('[data-recently-grid]', host);
    var current = $('[data-product-handle]');
    var currentHandle = current ? current.getAttribute('data-product-handle') : null;

    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return; }
    list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 5);
    if (!list.length) return;

    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '?section_id=card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      if (!html.trim()) return;
      grid.innerHTML = html;
      host.hidden = false;
    });
  }

  /* ---------- Barre d'achat sticky ---------- */
  function buybar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-add-btn]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '-70px 0px 0px 0px' }).observe(anchor);
    bar.querySelector('button').addEventListener('click', function () { anchor.click(); });
  }

  /* ---------- Accordéons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.acc__b');
    if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    if (panel) panel.classList.toggle('is-open', !open);
  });

  /* ---------- Init ---------- */
  function init() {
    countdowns(); delivery(); gallery(); variants(); buybar();
    rememberProduct(); recommendations(); recentlyViewed();
    if ($('#cart-drawer')) refreshCartCount();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
